module.exports = __webpack_public_path__ + "media/自然界声音-地理水文-水流声.be608821.wav";